module.exports = __webpack_public_path__ + "assets/img/help_image02-2@2x.af901a13.png";